import { useLocation } from "react-router-dom";

const Hamburger = () => {
    // resets the checkbox input so the navigation menu auto hides on navigation 
    const location = useLocation();

    return (
        <div className="w-12 h-12 flex flex-col justify-center items-end gap-2 relative peer lg:hidden">
            <input className="w-full h-full bg-blue-500 absolute inset-0 z-10 opacity-0 peer" type="checkbox" key={location.pathname}/> 
            <span className="w-12 h-[2px] bg-epic-blue -skew-x-[30deg] transition-all duration-300 peer-checked:translate-y-[5px] peer-checked:w-12"></span>
            <span className="w-8 h-[2px] bg-epic-blue -skew-x-[30deg] transition-all duration-300 peer-checked:-translate-y-[5px] peer-checked:w-12"></span>
        </div>
    )
}

export default Hamburger;